import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InitService {

  private estadoLayout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly currentEstadoLayout: Observable<boolean> = this.estadoLayout.asObservable();
  constructor() { }

  setEstadoLayout(estado: boolean):void {
    this.estadoLayout.next(estado);
  }
}
